import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { OnVoardLogo, OnVoardIcon } from 'components/Svg';
import MenuItem from '../MenuItem';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';



@observer
class CatalogMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = props.product;
    this.catalogUrl = utils.appendQueryString(paths.getPathCatalog(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.ADMIN_MENU.CATALOG);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.ADMIN_SIDEBAR.CATALOG;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.ADMIN_MENU.CATALOG}
        menuName="Catalog"
        icon="grid-alt"
        href={this.catalogUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}




@observer
class DataMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = props.product;

    this.importJobsUrl = utils.appendQueryString(paths.getPathImportJobs(), qs);
    this.exportJobsUrl = utils.appendQueryString(paths.getPathExportJobs(), qs);
    this.backgroundJobsUrl = utils.appendQueryString(paths.getPathBackgroundJobs(), qs);
    this.resourcesUrl = utils.appendQueryString(paths.getPathOnVoardResources(), qs);
    this.resourceAssociationsUrl = utils.appendQueryString(paths.getPathPredefinedResourceAssociations(), qs);
    this.taxonomiesUrl = utils.appendQueryString(paths.getPathTaxonomies(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.ADMIN_MENU.DATA);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.ADMIN_SIDEBAR.IMPORT_JOBS,
        label: "Import Jobs",
        href: this.importJobsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.importJobsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.IMPORT_JOBS
    }, {
        display: true,
        id: constants.ADMIN_SIDEBAR.EXPORT_JOBS,
        label: "Export Jobs",
        href: this.exportJobsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.exportJobsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.EXPORT_JOBS
    }, {
        display: true,
        id: constants.ADMIN_SIDEBAR.BACKGROUND_JOBS,
        label: "Background Jobs",
        href: this.backgroundJobsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.backgroundJobsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.BACKGROUND_JOBS
    }, {
        display: true,
        id: constants.ADMIN_SIDEBAR.RESOURCES,
        label: "Resources",
        href: this.resourcesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.resourcesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.RESOURCES
    }, {
        display: true,
        id: constants.ADMIN_SIDEBAR.RESOURCE_ASSOCIATIONS,
        label: "Resource Associations",
        href: this.resourceAssociationsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.resourceAssociationsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.RESOURCE_ASSOCIATIONS
    }, {
        display: true,
        id: constants.ADMIN_SIDEBAR.TAXONOMY,
        label: "Taxonomy",
        href: this.taxonomiesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.taxonomiesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.TAXONOMY
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.ADMIN_MENU.DATA}
        menuName="Data"
        icon="data"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}




@observer
class SettingsMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = props.product;

    this.accountsUrl = utils.appendQueryString(paths.getPathAccounts(), qs);
    this.usersUrl = utils.appendQueryString(paths.getPathUsers(), qs);
    this.customPagesUrl = utils.appendQueryString(paths.getPathCustomPages(), qs);
    this.affiliateProgramUrl = utils.appendQueryString(paths.getPathAffiliateProgram(), qs);
    this.partnerOverviewUrl = utils.appendQueryString(paths.getPathPartnerOverview(), qs);
    this.apiDetailsUrl = utils.appendQueryString(paths.getPathApiDetails(), qs);
    this.webhooksUrl = utils.appendQueryString(paths.getPathWebhooks(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.ADMIN_MENU.SETTINGS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: consoleStore.showSettingsMenu,
        id: constants.ADMIN_SIDEBAR.ACCOUNTS,
        label: "Accounts",
        href: this.accountsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.accountsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.ACCOUNTS
    }, {
        display: consoleStore.showSettingsMenu,
        id: constants.ADMIN_SIDEBAR.USERS_MANAGEMENT,
        label: "Users Management",
        href: this.usersUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.usersUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.USERS_MANAGEMENT
    }, {
        display: consoleStore.showSettingsMenu,
        id: constants.ADMIN_SIDEBAR.CUSTOM_PAGES,
        label: "Custom Pages",
        href: this.customPagesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.customPagesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CUSTOM_PAGES
    }, {
        display: consoleStore.showSettingsMenu,
        id: constants.ADMIN_SIDEBAR.API_DETAILS,
        label: "API Details",
        href: this.apiDetailsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.apiDetailsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.API_DETAILS
    }, {
        display: consoleStore.showSettingsMenu,
        id: constants.ADMIN_SIDEBAR.WEBHOOKS,
        label: "Webhooks",
        href: this.webhooksUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.webhooksUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.WEBHOOKS
    }, {
        display: false,
        id: constants.ADMIN_SIDEBAR.AFFILIATE_PROGRAM,
        label: "Affiliate Program",
        href: this.affiliateProgramUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.affiliateProgramUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.AFFILIATE_PROGRAM
    }, {
        display: false,
        id: constants.ADMIN_SIDEBAR.PARTNER_OVERVIEW,
        label: "Partner Overview",
        href: this.partnerOverviewUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.partnerOverviewUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.PARTNER_OVERVIEW
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.ADMIN_MENU.SETTINGS}
        menuName="Settings"
        icon="cog"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}



@observer
class BillingMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = props.product;
    this.subscriptionsUrl = utils.appendQueryString(paths.getPathSubscriptions(), qs);
    this.usagesUrl = utils.appendQueryString(paths.getPathUsages(), qs);
    this.invoicesUrl = utils.appendQueryString(paths.getPathInvoices(), qs);
    this.creditsUrl = utils.appendQueryString(paths.getPathCredits(), qs);
    this.partnerDealsUrl = utils.appendQueryString(paths.getPathPartnerDeals(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.ADMIN_MENU.BILLING);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    const account = consoleStore.account;

    let subMenus = [{
        display: consoleStore.showBillingMenu,
        id: constants.ADMIN_SIDEBAR.SUBSCRIPTIONS,
        label: "Subscriptions",
        href: this.subscriptionsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.subscriptionsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.SUBSCRIPTIONS
    }, {
        display: consoleStore.showBillingMenu,
        id: constants.ADMIN_SIDEBAR.USAGES,
        label: "Usages",
        href: this.usagesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.usagesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.USAGES
    }, {
        display: consoleStore.showBillingMenu && account.billedByOnVoard,
        id: constants.ADMIN_SIDEBAR.INVOICES,
        label: "Invoices",
        href: this.invoicesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.invoicesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.INVOICES
    }, {
        display: consoleStore.showBillingMenu && account.billedByOnVoard,
        id: constants.ADMIN_SIDEBAR.CREDITS,
        label: "Credits",
        href: this.creditsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.creditsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CREDITS
    }, {
        display: consoleStore.showBillingMenu && account.billedByOnVoard,
        id: constants.ADMIN_SIDEBAR.PARTNER_DEALS,
        label: "Partner Deals",
        href: this.partnerDealsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.partnerDealsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.PARTNER_DEALS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.ADMIN_MENU.BILLING}
        menuName="Billing"
        icon="credit-card"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}



@observer
class ControlMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = props.product;
    this.accountsUrl = utils.appendQueryString(paths.getPathControlAccounts(), qs);
    this.subscriptionsUrl = utils.appendQueryString(paths.getPathControlSubscriptions(), qs);
    this.usersUrl = utils.appendQueryString(paths.getPathControlUsers(), qs);
    this.connectionsUrl = utils.appendQueryString(paths.getPathControlConnections(), qs);
    this.couponsUrl = utils.appendQueryString(paths.getPathControlCoupons(), qs);
    this.partnersUrl = utils.appendQueryString(paths.getPathControlPartners(), qs);
    this.agenciesUrl = utils.appendQueryString(paths.getPathControlAgencies(), qs);
    this.integrationPartnersUrl = utils.appendQueryString(paths.getPathControlIntegrationPartners(), qs);
    this.emailTemplatesUrl = utils.appendQueryString(paths.getPathControlEmailTemplates(), qs);
    this.promptTemplatesUrl = utils.appendQueryString(paths.getPathControlPromptTemplates(), qs);
    this.segmentTemplatesUrl = utils.appendQueryString(paths.getPathControlSegmentTemplates(), qs);
    this.workflowPlaybooksUrl = utils.appendQueryString(paths.getPathControlWorkflowPlaybooks(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.ADMIN_MENU.CONTROL);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_ACCOUNTS,
        label: "Accounts",
        href: this.accountsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.accountsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_ACCOUNTS
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_SUBSCRIPTIONS,
        label: "Subscriptions",
        href: this.subscriptionsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.subscriptionsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_SUBSCRIPTIONS
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_USERS,
        label: "Users",
        href: this.usersUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.usersUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_USERS
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_CONNECTIONS,
        label: "Connections",
        href: this.connectionsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.connectionsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_CONNECTIONS
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_COUPONS,
        label: "Coupons",
        href: this.couponsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.couponsUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_COUPONS
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_PARTNERS,
        label: "Partners",
        href: this.partnersUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.partnersUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_PARTNERS
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_AGENCIES,
        label: "Agencies",
        href: this.agenciesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.agenciesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_AGENCIES
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_INTEGRATION_PARTNERS,
        label: "Integration Partners",
        href: this.integrationPartnersUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.integrationPartnersUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_INTEGRATION_PARTNERS
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_EMAIL_TEMPLATES,
        label: "Email Templates",
        href: this.emailTemplatesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailTemplatesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_EMAIL_TEMPLATES
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_PROMPT_TEMPLATES,
        label: "Prompt Templates",
        href: this.promptTemplatesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.promptTemplatesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_PROMPT_TEMPLATES
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_SEGMENT_TEMPLATES,
        label: "Segment Templates",
        href: this.segmentTemplatesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.segmentTemplatesUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_SEGMENT_TEMPLATES
    }, {
        display: consoleStore.showControlMenu,
        id: constants.ADMIN_SIDEBAR.CONTROL_WORKFLOW_PLAYBOOKS,
        label: "Workflow Playbooks",
        href: this.workflowPlaybooksUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.workflowPlaybooksUrl),
        isActive: activeSidebar === constants.ADMIN_SIDEBAR.CONTROL_WORKFLOW_PLAYBOOKS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.ADMIN_MENU.CONTROL}
        menuName="Control"
        icon="slider-alt"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}



@observer
class WriteReviewMenu extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const { history } = this.props;
    const account = consoleStore.account;

    return (
      <div className="menu-item">
        <a
          className="primary-link"
          href={constants.WRITE_REVIEW_URL}
          target="_blank"
          rel="noopener"
        >
          <Icon.Box icon="edit" />
          <span className="primary-label">Write Review</span>
        </a>
      </div>
    );
  }
}


@observer
class AdminMenuGroup extends React.Component {
  constructor (props) {
    super(props);
  }


  render() {
    const { activeMenu } = this.props;
    const account = consoleStore.account;

    return (
      <div className="menu-group admin-menu-group">
        <CatalogMenu
          isActive={activeMenu === constants.ADMIN_MENU.CATALOG}
          {...this.props}
        />

        {consoleStore.showSettingsMenu ? (
          <SettingsMenu
            isActive={activeMenu === constants.ADMIN_MENU.SETTINGS}
            {...this.props}
          />
        ): null}

        {consoleStore.showBillingMenu ? (
          <BillingMenu
            isActive={activeMenu === constants.ADMIN_MENU.BILLING}
            {...this.props}
          />
        ): null}

        {consoleStore.showControlMenu ? (
          <ControlMenu
            isActive={activeMenu === constants.ADMIN_MENU.CONTROL}
            {...this.props}
          />
        ): null}


        <WriteReviewMenu
          {...this.props}
        />

      </div>
    );
  }
}



export default AdminMenuGroup;
export { DataMenu };
